module.exports = __webpack_public_path__ + "static/img/11.f0dec34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/11.png
// module id = xQCk
// module chunks = 0